<app-training-record-delete #deleteRecordModal (deleted)="table.reload()"></app-training-record-delete>
<app-training-record-reminder #sendReminderForm></app-training-record-reminder>
<app-deprecated-modal-form
    #trainingRecordFormModal
    [form]="trainingRecordForm"
    (save)="trainingRecordForm.saveRecord()"
>
    <app-form-training-record
        #trainingRecordForm
        [record]="this.record"
        (saveRecordEvent)="table.reload()"
    ></app-form-training-record>
</app-deprecated-modal-form>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="{{ 'training.training' | translate }}" [menuService]="trainingModuleMenuService"></app-header>

    <app-table *ngIf="!table.isEmpty; else emptyState" [table]="table" (menuItemSelected)="menuAction($event)">
        <app-empty-state
            label="{{ 'training.noTrainingLogsFound' | translate }} MARANGO"
            src="/assets/illustrations/chair.png"
        ></app-empty-state>
    </app-table>

    <ng-template #emptyState>
        <ui-card class="empty" [withSpacing]="false">
            <div>
                <img src="/assets/illustrations/chair.png" />
                <h2 class="centered">{{ 'training.emptyState.title' | translate }}</h2>
                <p>{{ 'training.emptyState.description' | translate }}</p>

                <div class="emptyStateButtons flex align-items-center">
                    <ui-button type="outline" [externalLink]="true" [url]="learnMoreUrl" [openInNewTab]="true">
                        <span>{{ 'training.emptyState.learnMore' | translate }}</span>
                    </ui-button>
                    <ui-button type="primary" url="/training/programs/new">
                        <mat-icon svgIcon="plus" />
                        <span>{{ 'training.createTrainingProgram' | translate }}</span>
                    </ui-button>
                </div>
            </div>
        </ui-card>
    </ng-template>
</div>
